<template>
    <CommonList
            selection-type="radio"
            row-key="cstId"
            :has-more-search="false"
            :auto-load="true"
            ref="listRef"
            cellOverflow="ellipsis"
            @selection-change="handleSelectionChange"
            @current-row-change="handleCurrentRowChange"
            @load-start="handleLoadList"
            @search-click="handleLoadList"
            @pagination-change="handleLoadList"
            @reset-click="handleReset"
    >
        <!-- 固定搜索区 -->
        <template #search-item-fixed>
            <div class="common-search-item">
                <label class="common-search-label80">手机号：</label>
                <el-input v-model="searchForm.cstPhone" class="common-input120" placeholder="请输入"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">客户名称：</label>
                <el-input v-model="searchForm.cstName" class="common-input120" placeholder="请输入"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">客户类型：</label>
                <el-select v-model="searchForm.cstType" class="common-input100" placeholder="请选择">
                    <el-option v-for="item in Options.cst_type"
                               :key="item.enumCodeName+item.code"
                               :label="item.enumCodeName"
                               :value="item.code">
                    </el-option>
                </el-select>
            </div>
        </template>

        <!-- 通用操作按钮 -->
        <template #btn-group>
            <el-button type="primary" class="list-btn" @click="handleAdd">
                <el-icon><Plus/></el-icon>
                新增
            </el-button>
            <el-button
                    type="warning"
                    class="list-btn"
                    @click="handleEdit"
                    :disabled="!oneShow"
            >
            <el-icon><Edit/></el-icon>
            修改
            </el-button>
            <el-button
                    type="danger"
                    class="list-btn"
                    @click="handleDelete"
                    :disabled="!listShow"
            >
            <el-icon><Delete/></el-icon>
            删除
            </el-button>
        </template>

        <!-- 表格列 -->
        <template #table-column>
            <el-table-column prop="cstPhone" label="手机号" align="center" width="120"></el-table-column>
            <el-table-column prop="cstName" label="客户名称" align="center" min-width="180"></el-table-column>
            <el-table-column prop="cstType" label="客户类型" align="center" width="120">
                <template #default="scope">
                    {{ Options.cst_type.find(item => item.code === scope.row.cstType)?.enumCodeName || '加载中' }}
                </template>
            </el-table-column>
            <el-table-column label="客户地址" align="center" min-width="200">
                <template #default="scope">
                    {{ getFullAddressDisplay(scope.row) }}
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" align="center" min-width="180"></el-table-column>
            <el-table-column prop="isDeleted" label="是否生效" align="center" min-width="100" >
                <template #default="scope">
                    <el-tag :class="scope.row.isDeleted =='0'  ? 'list-status-normal' : 'list-status-deleted'">
                        {{ Options.isDeleted.find(item => item.code === scope.row.isDeleted)?.enumCodeName || '加载中' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="userName" label="录入人" align="center" min-width="160" :resizable="false"></el-table-column>
        </template>

        <!-- 新增/编辑弹窗 -->
        <template #extra>
            <el-dialog
                    v-model="dialogVisible"
                    :title="dialogType === 'add' ? '新增客户' : '修改客户'"
                    width="500px"
                    destroy-on-close
            >
                <el-form
                        ref="formRef"
                        :model="formData"
                        :rules="formRules"
                        label-width="100px"
                        class="list-modal-form"
                >
                    <el-form-item label="手机号" prop="cstPhone">
                        <el-input
                                v-model="formData.cstPhone"
                                placeholder="请输入手机号"
                                maxlength="11"
                                show-word-limit
                                style="width: 100%;"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="客户名称" prop="cstName">
                        <el-input
                                v-model="formData.cstName"
                                placeholder="请输入客户名称"
                                maxlength="100"
                                show-word-limit
                                style="width: 100%;"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="客户类型" prop="cstType">
                        <el-select
                                v-model="formData.cstType"
                                placeholder="请选择客户性质"
                                style="width: 100%;"
                        >
                            <el-option
                                    v-for="item in Options.cst_type"
                                    :key="item.enumCodeName + item.code"
                                    :label="item.enumCodeName"
                                    :value="item.code"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否生效" prop="isDeleted">
                        <el-radio-group v-model="formData.isDeleted">
                            <el-radio
                                    v-for="item in Options.isDeleted"
                                    :key="item.enumCodeName + item.code"
                                    :value="item.code"
                            >{{ item.enumCodeName }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="客户地址" prop="cstAddress">
                        <el-cascader
                                v-model="areaValue"
                                :options="fullAreaTree"
                                :props="{ expandTrigger: 'hover' }"
                                placeholder="请选择省市区"
                                style="width: 100%; margin-bottom: 10px;"
                                clearable
                        ></el-cascader>
                        <el-input
                                v-model="formData.cstAddressDetail"
                                type="textarea"
                                placeholder="请输入详细地址（选填）"
                                maxlength="250"
                                show-word-limit
                                :rows="2"
                                style="width: 100%;"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input
                                v-model="formData.remark"
                                type="textarea"
                                placeholder="请输入备注（选填）"
                                maxlength="250"
                                show-word-limit
                                :rows="3"
                                style="width: 100%;"
                        ></el-input>
                    </el-form-item>
                </el-form>
                <template #footer>
                    <div style="text-align: center; width: 100%;">
                        <el-button @click="dialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="handleSubmit">确定</el-button>
                    </div>
                </template>
            </el-dialog>
        </template>
    </CommonList>
</template>

<script setup>
    import useBillList from './cstMgtList.js'
    const {
        searchForm,
        listRef,
        dialogVisible,
        dialogType,
        formRef,
        oneShow,
        listShow,
        formData,
        formRules,
        Plus, Edit, Delete,
        handleSelectionChange,
        handleCurrentRowChange,
        handleAdd,
        handleEdit,
        handleDelete,
        handleLoadList,
        handleReset,
        handleSubmit,
        Options,
        areaValue,
        fullAreaTree,
        getFullAddressDisplay
    } = useBillList()
</script>
<style>
    @import '../../../assets/css/util/base-list.css';
</style>